import { styled } from '@mui/material/styles';
import { AUTH_LAYOUT_BACKGROUND_SRC } from 'common/constants/auth';
import { Box } from 'components/ui';

export const AuthLayoutRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  '&::before': {
    backgroundImage: `url(${AUTH_LAYOUT_BACKGROUND_SRC})`,
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    content: '""',
    inset: 0,
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
  },
  '&::after': {
    background: 'linear-gradient(248.954deg, #FFFFFF 50.357%, rgba(255, 255, 255, 0) 120.31%)',
    content: '""',
    inset: 0,
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
  },
  [theme.breakpoints.down('sm')]: {
    '&::before': {
      backgroundPosition: 'left bottom',
      backgroundSize: 'auto 100%',
    },
  },
}));

export const AuthLayoutContent = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginInline: 'auto',
  maxWidth: 1280,
  minHeight: 0,
  position: 'relative',
  width: '100%',
  zIndex: 1,
  [theme.breakpoints.up('lg')]: {
    paddingInline: theme.spacing(2),
  },
}));

export const AuthLayoutFormSlot = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
  padding: theme.spacing(3, 2, 2),
  WebkitOverflowScrolling: 'touch',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 3, 2.5),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 4, 3),
  },
}));
